import mbxDirections from '@mapbox/mapbox-sdk/services/directions';

const directionsClient = mbxDirections({
    accessToken: import.meta.env.VITE_MAPBOX_TOKEN,
});

// Define supported Mapbox routing modes
const VALID_MAPBOX_PROFILES = ['driving', 'walking', 'cycling'];

export async function fetchRouteChunk(coords, mode = 'driving') {
    if (!VALID_MAPBOX_PROFILES.includes(mode)) {
        return coords;
    }

    try {
        const response = await directionsClient.getDirections({
            profile: mode,
            geometries: 'geojson',
            overview: 'full',
            // overview: 'simplified', // Simplified for Routes Visualisation 
            waypoints: coords.map(coord => ({ coordinates: coord })),
        }).send();

        const route = response.body.routes?.[0];
        if (route?.geometry?.coordinates?.length) {
            return { 
            coordinates: route.geometry.coordinates,
            duration: route.duration || 0 // seconds
        };
        } else {
            console.log(`No route found (${mode}). Falling back to straight line.`, coords);
            return { coordinates: coords, duration: 0 };
        }
    } catch (err) {
        console.error(`Directions API failed for chunk (${mode}):`, coords, err);
        return { coordinates: coords, duration: 0 };
    }
}


export async function getBatchedRouteCoordinates(steps) {
    const cache = new Map();
    const cacheKey = steps.map(s => `${s.id}:${s.transport || 'driving'}`).join(',');

    if (cache.has(cacheKey)) return cache.get(cacheKey);

    const allSegments = [];
    let totalDurationSeconds = 0;

    for (let i = 0; i < steps.length - 1; i++) {
        const from = steps[i];
        const to = steps[i + 1];

        const coords = [from.point.coordinates, to.point.coordinates];
        const mode = from.transport || 'driving';

        const { coordinates, duration } = await fetchRouteChunk(coords, mode);
        allSegments.push(coordinates);
        totalDurationSeconds += duration;
    }

    const flattened = allSegments.flat();
    const result = {
        coordinates: flattened,
        durationHours: +(totalDurationSeconds / 3600).toFixed(2),
    };
    cache.set(cacheKey, result);
    return result;
}
